import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';
import { getAgentCenterAnalytics } from 'services/api/AgentCenterAPI';

const DEFAULT_AGENT_CENTER_ANALYTICS_DATA = {
    agentPerformance: {
        transfersHandled: 0,
        transfersCompletedToday: 0,
        transferOutcomesTotalToday: 0,
        transfersCompletedYesterday: 0,
        transferResponseRate: { value: 0, trendVsYesterdayPct: 0 },
        transferConversionRate: { value: 0, trendVsYesterdayPct: 0 },
        callbacksHandled: 0,
        callbackResponseRate: { value: 0, trendVsYesterdayPct: 0 },
        callbackConversionRate: { value: 0, trendVsYesterdayPct: 0 },
    },
    operational: {
        timeOnlineTodaySeconds: 0,
        waitingTimeSeconds: 0,
    },
    activityByHour: {
        buckets: [],
        timezone: '',
    },
};

export const useGetAgentCenterAnalytics = () => {
    const { data, isLoading, ...rest } = useQuery({
        queryKey: queryKeys.agentCenterAnalytics,
        queryFn: getAgentCenterAnalytics,
        refetchInterval: 30_000,
    });

    return {
        agentCenterAnalyticsData: data || DEFAULT_AGENT_CENTER_ANALYTICS_DATA,
        isAgentCenterAnalyticsLoading: isLoading,
        ...rest,
    };
};
